<script setup lang="ts">
import { useRouter } from "vue-router";
enum EventYourNavigationEnum {
    enterprise = "enterprise",
    administration = "admin",
}

type EventYourNavigationProps = {
    current: string;
};

defineProps<EventYourNavigationProps>();

const router = useRouter();
async function goTo(item: EventYourNavigationEnum) {
    await router.push(`/event-your/${item}`);
}
</script>

<template>
    <VFlex
        flex-direction="row"
        justify-content="center"
        column-gap="1em"
        class="p-3 has-background-white kart-navigation gradient-overlay">
        <VButton
            v-for="item in Object.values(EventYourNavigationEnum)"
            :key="item"
            :color="item === current ? 'info' : undefined"
            class="has-border-white is-uppercase is-button-navigation is-weight-500"
            @click="goTo(item)">
            <Translate>speed2max.eventYour.navigation.{{ item }}</Translate>
        </VButton>
        <!-- <img src="/images/kart/bg-kart.svg" alt="kart" /> -->
    </VFlex>
</template>

<style lang="scss" scoped>
.kart-navigation {
    position: fixed;
    overflow: hidden;
    z-index: 9;
    width: calc(100% - 320px);
    overflow-x: auto;

    > img {
        right: 0;
        top: 0;
        position: absolute;
        width: 300px;
    }
}

@media screen and (max-width: 1024px) {
    .kart-navigation {
        width: 100%;
    }
}

@media screen and (max-width: 650px) {
    .kart-navigation {
        display: ruby;
        flex-wrap: nowrap;
        overflow-x: visible;

        > .is-button-navigation {
            margin: 0 10px;
        }
    }

    .kart-navigation > img {
        display: none;
    }
}
</style>
